
import { useState } from 'react'
import OutputInvoice from './outputInvoice'
import OutputCustomer from './outputCustomer'
import OutputService from './outputService'
import './style.scss'

const Output = () => {

    const [outputInvoice, setOutputInvoice] = useState(false)
    const [outputCustomer, setOutputCustomer] = useState(false)
    const [outputService, setOutputService] = useState(false)

    return (
        <>
            <main className="accounting-list">
                <div className="user-info-container user-docs-container user-service-container mb-5 pb-5">
                    <div>خروجی نرم افزار حسابداری</div>
                    <hr />
                    <ul className="outpu-list">
                        <li onClick={() => { setOutputInvoice(true) }}>دریافت خروجی فاکتور‌ها</li>
                        <li onClick={() => { setOutputCustomer(true) }}>دریافت خروجی مشترک‌ها</li>
                        <li onClick={() => { setOutputService(true) }}>دریافت خروجی سرویس‌ها</li>
                    </ul>
                </div>
                {outputInvoice && <OutputInvoice setOutputInvoice={setOutputInvoice} />}
                {outputCustomer && <OutputCustomer setOutputCustomer={setOutputCustomer} />}
                {outputService && <OutputService setOutputService={setOutputService} />}
            </main>
        </>
    )
}
export default Output